export function openExtensionPage(target = '_blank') {
  return window.open(import.meta.env.VITE_EXTENSION_URL as string, target);
}
